export class UserDataBaseState {
  activeId: string;
  // Ephemeral map of user-data id -> revealed (decrypted) value, populated after
  // a successful sudo-authorized /reveal call. Cleared on hide / state reset.
  revealedContent: Record<string, string> = {};
}
